const tab_sections = {
    overview: 'Visión general',
    resource_management: 'Gestión de recursos',
    user_management: 'Gestión de usuarios',
    access_control: 'Control de acceso',
    help_and_support: 'Ayuda y soporte',
};
export default tab_sections;
